<div *ngIf="{vehicleDiagnosticsData: vehicleDiagnosticsData$ | async,
    linkedServiceData: linkedServiceData$ | async,
    loading: dataLoading$ | async,
    dealerBac: svcVehicleDiagnosticsRootFacade.dealerBac$ | async,
    linkedServiceVisitDtcsError: svcVehicleDiagnosticsRootFacade.linkedServiceVisitDtcsError$ | async,
    linkedServiceVisitMpviError: svcVehicleDiagnosticsRootFacade.linkedServiceVisitMpviError$ | async,
    linkedServiceVisitEcusError: svcVehicleDiagnosticsRootFacade.linkedServiceVisitEcusError$ | async,
    serviceVisitsByVinError: svcVehicleDiagnosticsRootFacade.serviceVisitsByVinError$ | async } as data">
  <div class="w-full sticky flex place-content-between">
    <div class="flex flex-row items-center space-x-4 h-9">
      <span class="text-xl font-medium">SAVI</span>
      <button mat-button *ngIf="data?.linkedServiceData?.linkedServiceVisit && !postedRO && data?.vehicleDiagnosticsData?.authenticatedEmployee?.jobTitleId !== 'TCH'"
        (click)="unlinkSaviRecord()">Unlink</button>
    </div>
    <div class="flex space-x-5" *ngIf="!postedRO && data?.vehicleDiagnosticsData?.authenticatedEmployee?.jobTitleId !== 'TCH'">
      <button type="button"
        (click)="retrySaviRequests(data?.vehicleDiagnosticsData?.routerParams['vin'], data?.vehicleDiagnosticsData?.routerParams['dealerCountryCode'], data?.vehicleDiagnosticsData?.businessId, data.dealerBac, data?.vehicleDiagnosticsData?.authenticatedUser)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
      </button>
      <button type="button"
        (click)="openGMSaviFilteringDialog(data?.vehicleDiagnosticsData?.routerParams['vin'], data?.vehicleDiagnosticsData?.routerParams['dealerCountryCode'], data?.vehicleDiagnosticsData?.businessId)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
        </svg>
      </button>
    </div>
  </div>
  <div *ngIf="data.loading === true; else loaded">
    <div class="flex flex-row border border-solid border-grey-300 rounded-lg w-full">
      <div class="flex flex-col w-full bg-grey-300 rounded-lg">
        <div class="flex flex-col pt-3 animated-background h-96 rounded-lg"></div>
      </div>
    </div>
  </div>
  <ng-template #loaded>
    <div class="flex flex-col pt-8" *ngIf="data?.linkedServiceData?.linkedServiceVisit; else noLinkedVisit">
      <div class="flex flex-row w-full text-xs font-medium uppercase">
        <span class="w-1/4">VIN</span>
        <span class="w-1/4">Odometer</span>
        <span class="w-1/4">Engine Light</span>
        <span class="w-1/4">Check-in</span>
      </div>
      <div class="flex flex-row w-full">
        <span class="w-1/4">{{data?.linkedServiceData?.linkedServiceVisit?.vin}}</span>
        <span class="w-1/4">{{data?.linkedServiceData?.linkedServiceVisit?.odometer}}</span>
        <span class="w-1/4">{{data?.linkedServiceData?.linkedServiceVisit?.engineLight}}</span>
        <span class="w-1/4">{{data?.linkedServiceData?.linkedServiceVisit?.checkInDate | date: 'shortDate'}},
          {{data?.linkedServiceData?.linkedServiceVisit?.checkInTime?.toString().substring(0,5)}}</span>
      </div>
      <div class="flex flex-row w-full pt-4 text-xs font-medium uppercase">
        <span class="w-1/4">Year</span>
        <span class="w-1/4">Make</span>
        <span class="w-1/4">Model</span>
        <span class="w-1/4">Color</span>
      </div>
      <div class="flex flex-row w-full">
        <span class="w-1/4">{{data?.linkedServiceData?.linkedServiceVisit?.modelYear}}</span>
        <span class="w-1/4">{{data?.linkedServiceData?.linkedServiceVisit?.makeName}}</span>
        <span class="w-1/4">{{data?.linkedServiceData?.linkedServiceVisit?.modelName}}</span>
        <span class="w-1/4">{{data?.linkedServiceData?.linkedServiceVisit?.color !== 'null' ?
          data?.linkedServiceData?.linkedServiceVisit?.color : 'N/A'}}</span>
      </div>
      <div class="flex flex-row w-1/3 pt-8">
        <ul class="flex list-none flex-wrap flex-row border-t border-grey-300">
          <li class="border-l border-grey-300 last:mr-0 flex-auto text-center">
            <span class="text-xs font-bold  text-grey-700 px-5 py-3  block leading-normal cursor-pointer"
              (click)="toggleTabs(0)" [ngClass]="{' bg-white': openTab !== 0, ' bg-grey-200': openTab === 0}">
              <i class="text-base mr-1"></i> MPVI
            </span>
          </li>
          <li class="border-l border-grey-300 last:mr-0 flex-auto text-center">
            <span class="text-xs font-bold  text-grey-700 px-5 py-3  block leading-normal cursor-pointer"
              (click)="toggleTabs(1)" [ngClass]="{' bg-white': openTab !== 1, ' bg-grey-200': openTab === 1}">
              <i class="text-base mr-1"></i> DTCs
            </span>
          </li>
          <li class="border-l border-r border-grey-300 last:mr-0 flex-auto text-center">
            <span class="text-xs font-bold text-grey-700 px-5 py-3  block leading-normal cursor-pointer"
              (click)="toggleTabs(2)" [ngClass]="{' bg-white': openTab !== 2, ' bg-grey-200': openTab === 2}">
              <i class="text-base mr-1"></i> ECUs
            </span>
          </li>
        </ul>
      </div>
      <div
        class="flex flex-col w-full h-auto overflow-y-auto border border-grey-300 px-3 mb-3 rounded-tr-lg rounded-b-lg">
        <div class="flex flex-wrap">
          <div class="w-full">
            <div class="relative flex flex-col min-w-0 break-words bg-white w-full">
              <div class="pt-2 flex-auto">
                <div class="tab-content tab-space">
                  <div [ngClass]="{'hidden': openTab !== 0, 'block': openTab === 0}">
                    <table class="w-full text-sm text-left">
                      <thead class="text-xs text-grey-700 uppercase">
                        <tr>
                          <th class="py-3 px-1 w-1/2">
                            Inspection Element
                          </th>
                          <th class="py-3 px-1 w-1/4">
                            Value
                          </th>
                          <th class="py-3 px-1 w-1/4">
                            Unit
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="bg-white border-grey-300"
                          *ngFor="let mpvi of data?.linkedServiceData?.serviceVisitMPVIs | orderBy: ['displayName'];  let i = index; let last = last"
                          [ngClass]="{'border-b-0': last, 'border-b': !last}">
                          <td class=" py-3 px-1 text-gray-900 w-1/2">
                            {{mpvi.displayName}}
                          </td>
                          <td class="py-3 px-1 w-1/4">
                            {{mpvi.value}}
                          </td>
                          <td class="py-3 px-1 w-1/4">
                            {{mpvi.unit}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div *ngIf="data?.linkedServiceVisitMpviError"
                      class="flex w-full h-full items-center place-content-center text-lg text-red-500 p-4">
                      Error retrieving Multi-Point Vehicle Inspection data
                    </div>
                  </div>

                  <div [ngClass]="{'hidden': openTab !== 1, 'block': openTab === 1}">
                    <table class="w-full text-sm text-left">
                      <thead class="text-xs text-grey-700 uppercase">
                        <tr>
                          <th class="py-3 px-1">
                            Control Modules
                          </th>
                          <th class="py-3 px-1  place-content-center">
                            Type
                          </th>
                          <th class="py-3 px-1  place-content-center">
                            DTC
                          </th>
                          <th class="py-3 px-1 place-content-center">
                            Symptom Code
                          </th>
                          <th class="py-3 px-1">
                            DTC Description
                          </th>
                          <th class="py-3 px-1">
                            Symptom Description
                          </th>
                          <th class="py-3 px-1  place-content-center">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="bg-white border-grey-300"
                          *ngFor="let dtc of data?.linkedServiceData?.serviceVisitDTCs | orderBy: ['dtcControlModule'];  let i = index; let last = last"
                          [ngClass]="{'border-b-0': last, 'border-b': !last}">
                          <td class="py-3 px-1 text-gray-900">
                            {{dtc.dtcControlModule}}
                          </td>
                          <td class="py-3 px-1">
                            {{dtc.dtcType}}
                          </td>
                          <td class="py-3 px-1">
                            {{dtc.dtcCode}}
                          </td>
                          <td class="py-3 px-1">
                            {{dtc.dtcSymptomCode}}
                          </td>
                          <td class="py-3 px-1">
                            {{dtc.dtcDescription}}
                          </td>
                          <td class="py-3 px-1">
                            {{dtc.dtcSymptomDescription}}
                          </td>
                          <td class="py-3 px-1">
                            {{dtc.dtcStatus}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div *ngIf="data?.linkedServiceVisitDtcsError"
                      class="flex w-full h-full items-center place-content-center text-lg text-red-500 p-4">
                      Error retrieving Diagnostic Trouble Code data
                    </div>
                  </div>

                  <div [ngClass]="{'hidden': openTab !== 2, 'block': openTab === 2}">
                    <table class="w-full text-sm text-left">
                      <thead class="text-xs text-grey-700 uppercase ">
                        <tr>
                          <th class="py-3 px-1 w-1/2">
                            Control Modules
                          </th>
                          <th class="py-3 px-1  place-content-center w-1/4">
                            Count
                          </th>
                          <th class="py-3 px-1  place-content-center w-1/4">
                            ECU Id
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="bg-white border-grey-300"
                          *ngFor="let ecu of data?.linkedServiceData?.serviceVisitECUs | orderBy: ['controlModule'];  let i = index; let last = last"
                          [ngClass]="{'border-b-0': last, 'border-b': !last}">
                          <td class=" py-3 px-1 text-gray-900 w-1/2">
                            {{ecu.controlModule}}
                          </td>
                          <td class="py-3 px-1 w-1/4">
                            {{ecu.count}}
                          </td>
                          <td class="py-3 px-1 w-1/4">
                            {{ecu.ecuId}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div *ngIf="data?.linkedServiceVisitEcusError"
                      class="flex w-full h-full items-center place-content-center text-lg text-red-500 p-4">
                      Error retrieving Engine Control Unit data
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noLinkedVisit>
      <div *ngIf="data.serviceVisitsByVinError; else noError"
        class="flex w-full h-full items-center place-content-center text-lg text-red-500">
        {{data.serviceVisitsByVinError?.statusCode === 404 || data.serviceVisitsByVinError?.statusCode === 403 ?
        data.serviceVisitsByVinError.error :
        'Error retrieving service visits, cannot link SAVI data'}}
      </div>
      <ng-template #noError>
        <span class="flex w-full text-lg justify-center pt-6">There is no SAVI data linked to this vehicle. </span>
        <span *ngIf="!postedRO && data?.vehicleDiagnosticsData?.authenticatedEmployee?.jobTitleId !== 'TCH'" class="flex w-full text-lg justify-center pt-6">Hit the <button type="button"
            (click)="retrySaviRequests(data?.vehicleDiagnosticsData?.routerParams['vin'], data?.vehicleDiagnosticsData?.routerParams['dealerCountryCode'], data?.vehicleDiagnosticsData?.businessId, data.dealerBac,data?.vehicleDiagnosticsData?.authenticatedUser)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-6 h-6 mx-1">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
          </button> button to retry the search for today's latest service visit.
        </span>
      </ng-template>
    </ng-template>
  </ng-template>
</div>